import React from "react";
// import styles from "./Reports.module.scss";
import Header from "components/general/Header/Header";
import Typography from "@material-ui/core/Typography";

const Reports = () => {
    return (
        <>
            <Header />
            <Typography variant="h1">Reports</Typography>
            <p>IEEEEEE</p>
        </>
    );
};

export default Reports;
